module.exports = __webpack_public_path__ + "images/temporary.b8b4ceee7d5b3f896cd94d4bf012e86e.png";